// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__1sLIt","checkboxCol":"Table_checkboxCol__3ubNO","emailCol":"Table_emailCol__1XtwT","actionCol":"Table_actionCol__1I_p-"};